exports.components = {
  "component---node-modules-gatsby-plugin-s-3-fake-index-js": () => import("./../../../node_modules/gatsby-plugin-s3/fake-index.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-s-3-fake-index-js" */),
  "component---src-components-page-index-tsx": () => import("./../../../src/components/page/index.tsx" /* webpackChunkName: "component---src-components-page-index-tsx" */)
}

